import { currentCountry } from '$services/shopify'

export default defineNuxtRouteMiddleware((_to, _from) => {
    const cookie = useCookie('cloudfront-viewer-country')
    if (cookie.value) {
        currentCountry.code = cookie.value
    }
})
